module.exports = __webpack_public_path__ + "static/cat-2-3f62a4ac815ae95920232d79fe1e9465.png";